// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"_2pp-N","primaryDarkButton":"_3HJBY","secondaryButton":"_OWE1","secondaryLightButton":"_3EwAz","tertiaryButton":"_11OEg","tertiaryDarkButton":"_3By9H"};